<template>
  <q-submenu
    v-if="menu.children !== undefined || menu.groups !== undefined"
    amn="sub-menu"
    :index="menu.index"
    :q-menu-key="menu.key"
  >
    <template slot="title">
      <font-awesome-icon
        v-if="menu.icon"
        :icon="['fas', menu.icon]"
      />
      <span slot="title">{{ menu.caption }}</span>
    </template>
    <template v-if="menu.groups !== undefined">
      <q-menu-item-group
        v-for="group in menu.groups"
        :key="group.caption"
        :q-menu-key="group.key"
      >
        <span slot="title">
          {{ group.caption }}
        </span>
        <template v-if="group.members">
          <q-menu-bar-item
            v-for="m in group.members"
            :key="m.index"
            :menu="m"
          />
        </template>
      </q-menu-item-group>
    </template>
    <template v-if="menu.children !== undefined">
      <q-menu-bar-item
        v-for="child in menu.children"
        :key="child.index"
        :menu="child"
      />
    </template>
  </q-submenu>
  <q-menu-item
    v-else
    :index="menu.index"
    :q-menu-key="menu.key"
  >
    <font-awesome-icon
      v-if="menu.icon"
      :icon="['fas', menu.icon]"
    />
    <span>{{ menu.caption }}</span>
  </q-menu-item>
</template>

<script>
  export default {
    name: 'QMenuBarItem',
    componentName: 'QMenuBarItem',

    props: {
      menu: {
        type: Object,
        default: undefined
      }
    },

    data() {
      return {};
    },

    methods: {},
  };
</script>
